import styled, { css } from 'styled-components';
import {
  SYS_COLOR_SURFACE_NEUTRAL_700_DARK,
  SYS_SPACE_FIXED_300,
  SYS_SPACE_FIXED_350,
} from '@oneaudi/unified-web-common';
import { ComponentContainerOptions } from '../../types';

export const Row = styled.div<{
  flexibleWidth?: boolean;
}>`
  display: flex;
  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    flex-direction: column;
    &:last-child div:last-child {
      border: none;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    justify-content: center;
    ${(props) =>
      !props.flexibleWidth &&
      css`
        > div {
          border-right: 1px solid ${({ theme }) => theme.colors.divider};
        }
      `};
    div:last-child {
      border-right: none;
    }
    &:not(:last-child) {
      margin-block-end: 1px;
    }
  }
`;

export const ComponentsContainer = styled.div`
  width: 100%;
  p {
    margin: 0;
  }
`;

export const ComponentContainer = styled.div<ComponentContainerOptions>`
  flex-grow: 1;
  background-color: ${SYS_COLOR_SURFACE_NEUTRAL_700_DARK};
  padding: ${SYS_SPACE_FIXED_300} ${SYS_SPACE_FIXED_350};
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.alignmentNumbers};
  justify-content: flex-start;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-delay: ${(props) => props.delay};
  text-align: ${(props) => props.alignmentNumbers};
  /* #margin-inline-start-left {
    margin-inline-start: 0px;
  } */

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    ${(props) => (props.flexibleWidth === true ? '' : 'width: 30%')};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    margin-block-end: 1px;
  }
`;
